export function cleanText(text: unknown) {
    if (!text || 'string' !== typeof text || '-' === text || '**clear**' === text || '**empty**' === text)
        return undefined;
    return text;
}

export default cleanText;
